import ourAgency from './OurAgency.json';

export const OurAgencyPresentation = () => {
    const { history } = ourAgency;
    
  return (
    <>
        <p>{ history }</p>
    </>
  )
}
